import React from "react";
import { useMutation, useQueryClient } from "react-query";
import { addOfficeAccount } from "../../../../../actions/Utilities/OfficeAccount";
import { toast } from "../../../../../components/toastNotification";
import { OfficeAccountType } from "../types";
import { addStateOfficeAccount, officeAccountReFetching } from "../atoms";
import { useRecoilState, useSetRecoilState } from "recoil";

export default function useAddOfficeAccount() {
  const setIsAddState = useSetRecoilState(addStateOfficeAccount);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeAccountReFetching
  );

  const { mutate } = useMutation(
    (NewData: OfficeAccountType) => addOfficeAccount(NewData),
    {
      onSuccess: (res: any) => {
        switch (res) {
          case "Success":
            toast.fire(
              "Success",
              "Office Account Added Successfully",
              "success"
            );
            break;
          case "Notification insert Failed!":
            toast.fire(
              "Success ",
              `Office Account Added Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case "Operation Failed!":
            toast.fire(
              "Adding Office Account failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case "The data already exists!":
            toast.fire(
              "Adding Office Account failed",
              `Duplication Error: ${res}`,
              "error"
            );
              break;
          case "Action object is null!":
              toast.fire(
                  "Adding Office Account failed",
                  `Error: ${res}`,
                  "error"
              );
            break;
          default:
            toast.fire("Adding Office Account failed", res.Message, "error");
        }
        
        // Redirect to View
        setIsAddState(false);
        
        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Office Account failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
}
